export default {
  rowNumber: "ردیف",
  to: "تا",
  from: "از",
  symbol: "رمز ارز",
  transactionId: "شناسه رهگیری",
  amount: "مقدار دریافتی",
  BCEQ: "ارزش در زمان دریافت",
  totalBCEQ: "مجموع ارزش در زمان دریافت",
  date: "زمان ثبت",
  payDate: "زمان پرداخت",
  registerDate: "زمان ثبت‌نام",
  description: "بابت",
  giftListIsEmpty: "هیچ هدیه‌ای وجود ندارد",
  invited: "دعوت شده",
  totalReward: "مجموع ارزش پاداش‌ها در زمان دریافت",
  totalTooltip1: "این مقدار نشان دهنده مجموع ارزش تتری رمز ارزها ",
  totalTooltip2: "در زمان دریافت ",
  totalTooltip3: "آن ها است و",
  totalTooltip4: " ارزش فعلی",
  totalTooltip5: " پاداش ها را میتوانید در کیف پولتان ببینید.",
  giftsAndRemains: "پاداش‌های مانده حساب و جشنواره‌ها",
  recieveReward:
    "با نگه داشتن رمز ارزهای‌ خود در کیف پول اکسکوینو و شرکت در جشنواره‌های متنوع، می‌توانید پاداش‌ دریافت کنید.",
  guidAndRules: "راهنما و قوانین پاداش‌ها",
  todayGuidValue: "ارزش پاداش‌های امروز",
  rewardList: "لیست پاداش‌ها",
  endOfCampain: "پایان کمپین",
  no_reward_yet: "هنوز پاداشی دریافت نکرده‌اید"
};
